module.exports = __webpack_public_path__ + "static/media/manchester_6.31c27e63.png";